<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">
        {{ $t('administration.employee.employeeProfile.previewCard') }}
      </h4>
      <ts-modal-close-button />
    </div>
    <ts-loading-banner :loading="loading">
      <ts-card-wrapper>
        <div
          class="table-responsive drive-items-table-wrapper ts-overflow-y-auto ts-overflow-x-hidden"
          style="max-height: 65vh;"
        >
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th class="type">Employee Card</th>
                <th class="employeeName">Employee Name</th>
                <th class="employeeCardSide">Card Side</th>
                <th class="text-center" width="1%">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(urlImage, index) in urlImages"
                :key="index"
                class="ts-cursor-pointer"
              >
                <td class="type" valign="bottom">
                  <img
                    class="h-full w-full rounded-lg object-cover shadow-lg"
                    :icon-size="iconSize"
                    :src="urlImage.url"
                    alt=""
                    v-viewer="{ toolbar: false }"
                    loading="lazy"
                    style="max-height: 106px;"
                  />
                </td>
                <td class="employeeName" valign="bottom">
                  {{ urlImage.employee_name }}
                </td>
                <td class="employeeName" valign="bottom">
                  {{ urlImage.side }}
                </td>
                <td class="text-center ts-space-x-2" valign="bottom">
                  <a
                    @click.prevent="download(urlImage.url)"
                    v-tooltip="'Download'"
                    class="text-primary"
                    ><i class="fa fa-download"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ts-card-wrapper>
    </ts-loading-banner>
  </ts-card>
</template>
<script>
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)
import * as FileDownload from 'downloadjs'
export default {
  name: 'previewCardDownload',
  props: {
    id_list: {
      type: Array
    },
    side: {
      type: String
    },
    type: {
      type: String
    },
    font_size_en: {
      type: String
    },
    font_size_kh: {
      type: String
    }
  },
  data() {
    return {
      iconSize: 'fa-2x',
      loading: false,
      urlImages: ''
    }
  },
  created() {
    this.previewCardDownload()
  },
  methods: {
    previewCardDownload() {
      this.loading = true
      this.$store
        .dispatch('employee/printCard', {
          staff_id_list: this.id_list,
          side: this.side,
          type: this.type,
          font_size_en: this.font_size_en,
          font_size_kh: this.font_size_kh
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.loading = false
          this.urlImages = response.url_images
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = true
        })
    },
    download(data) {
      FileDownload(data)
    }
  }
}
</script>

<style scoped>
#container {
  width: 100%;
  height: 70vh;
  text-align: center;
}
#container iframe {
  width: 100%;
  height: 70vh;
  border: 2px solid #acacac;
}
#container i {
  margin-top: 32vh;
  color: white;
}
</style>
